export default {
  profile: {
    url: "https://my-json-server.typicode.com/facuc28/mock-data/profile"
  }
};
